import AttachmentTable from './AttachmentsTable';
import { SideSheet, SideSheetHeader } from '../../../layouts';
import { convertDateToDayJs } from '../../../utils/dateTimeUtils';
import { formatDayJsDate } from '../../../utils/dateTimeUtils';
import {
  getDropdownLabelText,
  getFormattedAmount,
} from '../../../utils/form';
import { HeadingWizard } from '../..';

interface ExpenseClaimLineItemDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  lineItemData: any;
  attachments: any[];
  travelRequestId: number;
  formConfig: any;
  headerChildren?: React.ReactNode;
}

function GridDataPoint({
  config,
}: {
  config: { label: string; value: React.ReactNode };
}) {
  const { label, value } = config;
  return (
    <div className="flex flex-col gap-y-1">
      <div className="font-semibold text-text-200 text-xs">{label}</div>
      <div className="font-normal text-text-400 text-xs">{value}</div>
    </div>
  );
}

const ExpenseClaimLineItemDetails = ({
  isOpen,
  onClose,
  lineItemData,
  attachments,
  travelRequestId,
  // formConfig,
  headerChildren,
}: ExpenseClaimLineItemDetailsProps) => {
  if (!isOpen) return null;
  // const fields = formConfig?.expenseClaimForm?.fields;
  return (
    <SideSheet
      isOpen={isOpen}
      closeOnClickOutside={true}
              addOnClass="w-full max-w-none md:!w-[50vw]"
      onClose={onClose}
      contentChildren={
        <div className="flex flex-col gap-4 p-3">
          {lineItemData && (
            <div className="flex flex-col gap-3">
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                <GridDataPoint
                  config={{
                    label: 'Expense Type',
                    value:
                      lineItemData.expenseType?.label ||
                      lineItemData.travelExpense?.name ||
                      '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'From Date',
                    value: lineItemData.fromDate
                      ? formatDayJsDate(
                          convertDateToDayJs(lineItemData.fromDate),
                        )
                      : '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'To Date',
                    value: lineItemData.toDate
                      ? formatDayJsDate(convertDateToDayJs(lineItemData.toDate))
                      : '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'No of Days',
                    value: lineItemData.noOfDays || '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'From Country',
                    value:
                      lineItemData.fromCountry?.label ||
                      lineItemData.travelFromCountry?.LongDescription ||
                      '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'From City',
                    value:
                      lineItemData.fromCity?.label ||
                      lineItemData.travelFromCity?.ShortDescription ||
                      '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'To Country',
                    value:
                      lineItemData.toCountry?.label ||
                      lineItemData.travelToCountry?.LongDescription ||
                      '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'To City',
                    value:
                      lineItemData.toCity?.label ||
                      lineItemData.travelToCity?.ShortDescription ||
                      '-',
                  }}
                />

                <GridDataPoint
                  config={{
                    label: 'Amount',
                    value: lineItemData.hasRefund ? (
                      <span style={{ color: 'red' }}>
                        -{getFormattedAmount(lineItemData.amount)}
                      </span>
                    ) : (
                      getFormattedAmount(lineItemData.amount) || '-'
                    ),
                  }}
                />
                {/* <GridDataPoint
                  config={{
                    label: 'Approved Amount',
                    value:
                      lineItemData.approvedAmount !== null &&
                        lineItemData.approvedAmount !== undefined
                        ? getFormattedAmount(lineItemData.approvedAmount)
                        : '-',
                  }}
                /> */}
                <GridDataPoint
                  config={{
                    label: 'Currency',
                    value:
                      lineItemData.currency?.label ||
                      lineItemData.travelCurrency?.CurrencyName ||
                      '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Cancellation Charges',
                    value:
                      lineItemData.cancellationCharges !== null &&
                      lineItemData.cancellationCharges !== undefined
                        ? getFormattedAmount(lineItemData.cancellationCharges)
                        : '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Customer',
                    value:
                      lineItemData.customer?.label ||
                      lineItemData.travelCustomer?.name ||
                      '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Bill To Customer',
                    value: lineItemData.billToCustomer ? 'Yes' : 'No',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Cancellation Reason',
                    value: lineItemData.cancellationReason || '-',
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Remarks',
                    value: lineItemData.remarks || '-',
                  }}
                />
              </div>
            </div>
          )}

          {/* <GridDataPoint
                  config={{
                    label: 'Is Personal Expense',
                    value: lineItemData.isPersonalExpense ? 'Yes' : 'No',
                  }}
                /> */}
          <div className="flex flex-col gap-y-2">
            <HeadingWizard addOnClass="text-base">Other Details</HeadingWizard>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
              <GridDataPoint
                config={{
                  label: 'Payment Method',
                  value:
                    lineItemData.paymentMethod?.label ||
                    lineItemData.travelPaymentMethod?.name ||
                    '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Invoice Number',
                  value: lineItemData.invoiceNo || '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'PNR No',
                  value: lineItemData.pnrNo || '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Invoice Date',
                  value: lineItemData.invoiceDate
                    ? formatDayJsDate(
                        convertDateToDayJs(lineItemData.invoiceDate),
                      )
                    : '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Hotel Name',
                  value: lineItemData.hotelName || '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Hotel Address',
                  value: lineItemData.hotelAddress || '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Hotel Phone No.',
                  value: lineItemData.hotelPhoneNumber || '-',
                }}
              />

              <GridDataPoint
                config={{
                  label: 'GSTIN',
                  value: lineItemData.gstIn || '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Hotel Country',
                  value:
                    getDropdownLabelText(lineItemData?.hotelCountry?.label) ||
                    lineItemData?.travelHotelCountry?.LongDescription ||
                    '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Hotel State',
                  value:
                    getDropdownLabelText(lineItemData.hotelState?.label) ||
                    lineItemData?.travelHotelState?.ShortDescription ||
                    '-',
                }}
              />
              <GridDataPoint
                config={{
                  label: 'Hotel City',
                  value:
                    getDropdownLabelText(lineItemData.hotelCity?.label) ||
                    lineItemData.travelHotelCity?.ShortDescription ||
                    '-',
                }}
              />
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <h2 className="text-md">Attachments</h2>
            <AttachmentTable
              attachments={attachments || []}
              travelRequestId={travelRequestId}
            />
          </div>
        </div>
      }
      headerChildren={
        <div className="border-b border-gray-100">
          {headerChildren || (
            <SideSheetHeader
              title="Expense Claim Details"
              onCloseClick={onClose}
            />
          )}
        </div>
      }
      footerChildren={<></>}
    />
  );
};

export default ExpenseClaimLineItemDetails;
